import {ApiClient} from '@hconnect/apiclient'
import {Iso8601} from '@hconnect/common/types'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {mapManualKpis} from '../mappers'
import {ManualKpi, ManualKpiDto, ManualKpiResolution} from '../types'

export const ManualKpisQueryKey = 'manual-kpis'

type UseManualKpisParams = {
  plantId: string
  resolution: ManualKpiResolution
  timestamp: Iso8601
  timezone: string
  options?: Omit<UseQueryOptions<ManualKpi[], AxiosError>, 'queryKey'>
}

export const useManualKpis = ({
  plantId,
  resolution,
  timestamp,
  timezone,
  options
}: UseManualKpisParams) => {
  const path = `/shifthandover/${plantId}/kpi/${resolution}/${timestamp}`

  return useQuery<ManualKpi[], AxiosError>({
    queryKey: [ManualKpisQueryKey, path, timezone],
    queryFn: async () => {
      const response = await ApiClient.axiosInstance.get<ManualKpiDto[]>(path)
      return mapManualKpis(response.data, timezone)
    },
    ...options
  })
}
